import React, { useState } from "react";
import PropTypes from "prop-types";

import { DataGrid, GridRowModes, GridToolbarContainer } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import { Add as AddIcon, Delete as DeleteIcon, Edit } from "components/icons";
// import SaveIcon from '@mui/icons-material/Save';
// import CancelIcon from '@mui/icons-material/Close';

import CustomNoRowsOverlay from "app/components/overlays/CustomNoRowsOverlay";
// import { fetchSingleActivity } from "app/services/member.service";
import LinearProgress from "@mui/material/LinearProgress";
import MDBox from "components/MDBox";
import { FilterAndExportGridToolbar } from "app/components/overlays/FilterAndExportGridToolbar";
// import { handleAxiosError } from "app/services/app.error.handler";
import { isEmpty } from "utils/validationUtil";
import { IconButton } from "@mui/material";
import { getClientCodeFromEmail } from "utils/clientUtil";
import { getDateInDDMMYYYYFormat } from "utils/dateUtil";
import { ROLE_EMPLOYEE_MEMBER } from "AppConstants";
import "./AddActivityForm.css";

function EditToolbar(props) {
  const { setRows, setRowModesModel } = props;

  const handleClick = () => {
    const id = 1;
    setRows((oldRows) => [...oldRows, { id, startDate: "", endDate: "", Member: "", isNew: true }]);
    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "startDate" },
    }));
  };

  return (
    <GridToolbarContainer>
      <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
        Add record
      </Button>
    </GridToolbarContainer>
  );
}

EditToolbar.propTypes = {
  setRowModesModel: PropTypes.any.isRequired,
  setRows: PropTypes.any.isRequired,
};

// Accepts activitiesData property from parent
export const ActivityDataGridBaseEditable = (props) => {
  const [pageSize, setPageSize] = useState(10);
  // const [rows, setRows] = React.useState([]);
  // const [rowModesModel, setRowModesModel] = React.useState({});

  const getData = () => {
    if (isEmpty(props?.activitiesData) || props?.activitiesData?.length === 0) return [];
    else return props?.activitiesData;
  };

  // const handleRowEditStart = (params, event) => {};

  // const handleRowEditStop = (params, event) => {
  //   params.row.status = params.row.status.replace(" ", "_");
  //   updateSingleActivityInBackend(params.row.id, params.row);
  // };

  // const handleSaveClick = (id) => () => {
  //   setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  // };

  // const handleCancelClick = (id) => () => {
  //   setRowModesModel({
  //     ...rowModesModel,
  //     [id]: { mode: GridRowModes.View, ignoreModifications: true },
  //   });
  // };

  // const getSingleActivityFromBackend = async (id) => {
  //   await fetchSingleActivity(id)
  //     .then((response) => {})
  //     .catch((error) => {
  //       handleAxiosError(error);
  //     });
  // };

  // const processRowUpdate = (newRow) => {
  //   const updatedRow = { ...newRow, isNew: false };
  //   setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
  //   return updatedRow;
  // };

  // const handleRowModesModelChange = (newRowModesModel) => {
  //   setRowModesModel(newRowModesModel);
  // };

  const handleEvent = (params) => {
    props.editDialogHandler(params.row);
  };

  const columns = [
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: (obj) => {
        return [
          <IconButton aria-label="Edit" onClick={() => handleEvent(obj)} color="inherit">
            <Edit />
          </IconButton>,
          <IconButton
            aria-label="Delete"
            onClick={() => props.confirmDialogHandler(obj.id)}
            color="inherit"
          >
            <DeleteIcon />
          </IconButton>,
        ];
      }, // getAction
    },
    {
      field: "startDate",
      headerName: "Start Date",
      type: "date",
      width: 180,
      editable: false,
      valueGetter: (value, row) => getDateInDDMMYYYYFormat(row.startDate),
    },
    {
      field: "endDate",
      headerName: "End Date",
      type: "date",
      width: 120,
      editable: false,
      valueGetter: (value, row) => getDateInDDMMYYYYFormat(row.endDate),
    },
    { field: "hoursSpent", headerName: "Hours Spent", type: "number", width: 150, editable: false },
    { field: "clientTicketRef", headerName: "Client Ticket Ref", width: 150, editable: false },
    { field: "description", headerName: "Description", width: 400, editable: false },
    {
      field: "owner_name",
      headerName: "Member",
      width: 200,
      editable: false,
      valueGetter: (value, row) => row.owner.name,
    },
    {
      field: "client_name",
      headerName: "Client",
      width: 100,
      editable: false,
      hide: props.role === ROLE_EMPLOYEE_MEMBER ? true : false,
      valueGetter: (value, row) => getClientCodeFromEmail(row.owner.email),
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      editable: false,
      valueGetter: (value, row) => row.status.replace("_", " "),
      type: "singleSelect",
      valueOptions: ["OPEN", "COMPLETED", "IN PROGRESS", "ON HOLD", "CANCELLED", "CLOSED"],
    },
    {
      field: "approvalStatus",
      headerName: "Approval Status",
      width: 150,
      editable: false,
      valueGetter: (value, row) => row.approvalStatus || "SUBMITTED",
      cellClassName: (params) => {
        const status = params.row.approvalStatus || "SUBMITTED";
        return `approval-status--${status.toLowerCase()}`;
      },
    },

  ];

  return (
    <MDBox pt={3} py={3} px={2} height={500}>
      <DataGrid
        density="compact"
        rows={getData()}
        columns={columns}
        editMode="row"
        // onRowClick={handleEvent}
        // rowModesModel={rowModesModel}
        // onRowModesModelChange={handleRowModesModelChange}
        // onRowEditStart={handleRowEditStart}
        // onRowEditStop={handleRowEditStop}
        // processRowUpdate={processRowUpdate}
        slots={{
          toolbar: EditToolbar,
        }}
        // slotProps={{
        //     toolbar: { setRows, setRowModesModel },
        // }}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 20]}
        components={{
          Toolbar: FilterAndExportGridToolbar,
          LoadingOverlay: LinearProgress,
          NoRowsOverlay: CustomNoRowsOverlay,
        }}
        // loading
        getCellClassName={(params) =>
          params.field === "status" ? `activity-app-theme--${params.row.status.toLowerCase()}` : ""
        }
        //getRowId={(activity)=> activity.id}
      />
    </MDBox>
  );
};

ActivityDataGridBaseEditable.propTypes = {
  activitiesData: PropTypes.array.isRequired,
};
